import Grid from '@material-ui/core/Grid'
import React, { FC } from 'react'

//* utils
import { TopicCTA } from '../../../models/topics/cta'
import { internalLinkHandler } from '../../../utils/link.utils'
import { renderRichText } from '../../../utils/richTextHandler.utils'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import { ComponentColumns } from '../../../models/components/columns'
import Button from '../button'

type Props = {
  data: ComponentColumns
  theme: string
}

export const Content: FC<Props> = ({ data, theme }) => {
  const column1 = {
    cta: data.column1Cta || {},
    headline: data.column1Headline || '',
    body: data.column1Body || '',
    icon: data.column1Icon?.file.url || {},
    displayColumn: !!data.column1Headline,
  }

  const column2 = {
    cta: data.column2Cta || {},
    headline: data.column2Headline || '',
    body: data.column2Body || '',
    icon: data.column2Icon?.file.url || {},
    displayColumn: !!data.column2Headline,
  }

  const column3 = {
    cta: data.column3Cta || {},
    headline: data.column3Headline || '',
    body: data.column3Body || '',
    icon: data.column3Icon?.file.url || {},
    displayColumn: !!data.column3Headline,
  }

  const column4 = {
    cta: data.column4Cta || {},
    headline: data.column4Headline || '',
    body: data.column4Body || '',
    icon: data.column4Icon?.file.url || {},
    displayColumn: !!data.column4Headline,
  }

  const column5 = {
    cta: data.column5Cta || {},
    headline: data.column5Headline || '',
    body: data.column5Body || '',
    icon: data.column5Icon?.file.url || {},
    displayColumn: !!data.column5Headline,
  }

  const column6 = {
    cta: data.column6Cta || {},
    headline: data.column6Headline || '',
    body: data.column6Body || '',
    icon: data.column6Icon?.file.url || {},
    displayColumn: !!data.column6Headline,
  }

  const getColCount = () => {
    if (column6.displayColumn) {
      return 6
    } else if (column5.displayColumn) {
      return 5
    } else if (column4.displayColumn) {
      return 4
    } else if (column3.displayColumn) {
      return 3
    } else {
      return 2
    }
  }

  const colsCount = getColCount()
  const generateContentItem = (heading: string, body: any, cta: TopicCTA, icon: any) => {
    const itemInner = (
      <div className={`ContentColumns__Item`}>
        {icon.length && (
          <div className="ContentColumns__Item-Image">
            <img src={icon} alt={'sdsd'} />
          </div>
        )}
        {heading && <h3 className="ContentColumns__Item-Heading">{formatInlineCode(heading)}</h3>}

        {body && (
          <div className="ContentColumns__Item-Body ContentColumns__Item-List">
            {renderRichText(body)}
          </div>
        )}

        {cta?.text && (
          <Button
            icon={true}
            href={cta.internalLink ? internalLinkHandler(cta.internalLink) : cta.externalUrl}
            text={cta.text}
            type="text-link"
            size="small"
            theme={theme.toLowerCase()}
          />
        )}
      </div>
    )

    if (colsCount === 6 || colsCount === 5 || colsCount === 3) {
      return (
        <Grid className="ContentColumns__Grid-Item" item xs={12} sm={6} md={4}>
          {itemInner}
        </Grid>
      )
    }

    if (colsCount === 4) {
      return (
        <Grid className="ContentColumns__Grid-Item" item xs={12} sm={6} md={3}>
          {itemInner}
        </Grid>
      )
    }

    if (colsCount === 2 || colsCount === 1) {
      return (
        <Grid className="ContentColumns__Grid-Item" item xs={12} sm={6}>
          {itemInner}
        </Grid>
      )
    }
  }

  return (
    <Grid container spacing={2}>
      {column1.displayColumn &&
        generateContentItem(column1.headline, column1.body, column1.cta, column1.icon)}
      {column2.displayColumn &&
        generateContentItem(column2.headline, column2.body, column2.cta, column2.icon)}
      {column3.displayColumn &&
        generateContentItem(column3.headline, column3.body, column3.cta, column3.icon)}
      {column4.displayColumn &&
        generateContentItem(column4.headline, column4.body, column4.cta, column4.icon)}
      {column5.displayColumn &&
        generateContentItem(column5.headline, column5.body, column5.cta, column5.icon)}
      {column6.displayColumn &&
        generateContentItem(column6.headline, column6.body, column6.cta, column6.icon)}
    </Grid>
  )
}
